import React, { useEffect, useRef, useState } from "react";
import { useAuthContext } from "@/hooks/useAuthContext";
import { Card, CardContent } from "@/shadcn/components/ui/card";
import { Button } from "@/shadcn/components/ui/button";

import { Checkbox } from "@/shadcn/components/ui/checkbox";
import { useFirestore } from "@/hooks/useFirestore";
import { CheckCircledIcon, CopyIcon } from "@radix-ui/react-icons";
import { useCollection } from "@/hooks/useCollection";
import { useReferrerContext } from "@/hooks/useReferrerContext";
import { Input } from "@/shadcn/components/ui/input";
import Loading from "@/components/Loading";

export default function Refer2() {
  const { user } = useAuthContext();
  const { referrerDoc2 } = useReferrerContext();
  const { updateDocument: updateReferral } = useFirestore(
    "referrals2",
    user.uid
  );
  const { documents: referrals2 } = useCollection(
    "referrals2",
    null,
    ["totalPurchases", "desc"],
    null,
    8
  );
  const { documents: rewardPurchases } = useCollection("rewardPurchases", [
    "referrerId",
    "==",
    referrerDoc2.referrerId,
  ]);
  const [userAcceptedTerms, setUserAcceptedTerms] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [analytics, setAnalytics] = useState(undefined);
  const [textCopied, setTextCopied] = useState("");
  const [paymentDetails, setPaymentDetails] = useState({
    name: "",
    pixKey: "",
  });
  const generateLink = useRef(false);
  const isFetchingAnalytics = useRef(false);
  const isFixingLinks = useRef(false);

  const subscribeToRewardsProgram = async () => {
    if (!userAcceptedTerms) {
      setErrorMessage("Você precisa aceitar os termos para participar.");
      return;
    }
    await updateReferral(user.uid, { acceptedTerms2: true });
  };

  async function copyToClipboard(text, what) {
    try {
      await navigator.clipboard.writeText(text);
      setTextCopied(what);
      setTimeout(() => {
        setTextCopied("");
      }, 3000);
    } catch (err) {
      console.error("Falha ao copiar o texto para o clipboard:", err);
    }
  }

  const getRankColor = (index) => {
    switch (index) {
      case 0:
        return "bg-yellow-500 text-white";
      case 1:
        return "bg-gray-500 text-white";
      case 2:
        return "bg-yellow-600 text-white";
      default:
        return "bg-gray-200 text-gray-900";
    }
  };

  const savePaymentDetails = async () => {
    await updateReferral(user.uid, {
      paymentDetails: paymentDetails,
    });
  };

  useEffect(() => {
    // async function fixLinks() {
    //   if (isFixingLinks.current) return;
    //   isFixingLinks.current = true;

    //   await updateReferral(user.uid, { regenerateLink: true });
    //   console.log("ran fixLinks");
    // }

    async function getLinkAnalytics() {
      if (isFetchingAnalytics.current) return;
      isFetchingAnalytics.current = true;

      let idToken;
      try {
        idToken = await user.getIdToken();
      } catch (err) {
        alert("Erro ao obter TA.");
        return;
      }
      const url =
        "https://us-central1-trading-app-e0773.cloudfunctions.net/getLinkAnalytics";

      try {
        const response = await fetch(url, {
          method: "POST",
          body: JSON.stringify({
            checkoutUrl: referrerDoc2.checkoutLink,
            videoUrl: referrerDoc2.videoLink,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        });
        const data = await response.json();
        if (data) {
          setAnalytics(data);
        } else {
          setAnalytics({
            checkoutUrlTotalClicks: 0,
            videoUrlTotalClicks: 0,
          });
        }
      } catch (err) {
        setAnalytics({
          checkoutUrlTotalClicks: 0,
          videoUrlTotalClicks: 0,
        });
        console.error("Erro ao buscar dados de analytics:", err);
      }
    }

    if (referrerDoc2 && referrerDoc2.paymentDetails) {
      setPaymentDetails(referrerDoc2.paymentDetails);
    }

    // if (referrerDoc2 && referrerDoc2.acceptedTerms) {
    //   if (
    //     !referrerDoc2.checkoutLink &&
    //     !referrerDoc2.videoLink &&
    //     generateLink.current === false
    //   ) {
    //     if (!referrerDoc2.regenerateLink) {
    //       generateLink.current = true;
    //       fixLinks();
    //     }
    //   }
    // }

    if (referrerDoc2 && referrerDoc2.checkoutLink && referrerDoc2.videoLink) {
      getLinkAnalytics();
    }
  }, [referrerDoc2]);

  const isActiveReferrer =
    referrerDoc2 && referrerDoc2.checkoutLink && referrerDoc2.videoLink;

  if (
    (isActiveReferrer && analytics === undefined) ||
    rewardPurchases === undefined
  ) {
    return <Loading />;
  }

  const getVideoPurchases = () => {
    return (
      rewardPurchases?.filter((purchase) => purchase.referrer.includes("video"))
        .length || 0
    );
  };

  const getPayPurchases = () => {
    return (
      rewardPurchases?.filter((purchase) => purchase.referrer.includes("pay"))
        .length || 0
    );
  };

  return (
    <div className="mt-5 px-2.5 py-12 lg:px-0 lg:py-5 w-full xl:w-3/5 mx-auto 2xl:w-2/5">
      <div className="px-1 lg:px-0">
        {" "}
        <h1 className="font-medium text-xl">Programa de Recompensas</h1>
        <p className="text-muted-foreground font-light text-md text-left">
          Indique a Money Academy para seus amigos e conhecidos e ganhe 100
          reais por indicação válida.
        </p>
      </div>

      <Card className="mt-2.5 w-full">
        <CardContent className="p-5">
          {referrerDoc2.acceptedTerms2 ? (
            <>
              <h3>Copie seus links abaixo e compartilhe para ganhar</h3>
              <p className="text-sm mt-5 mb-1.5">
                Vídeo de apresentação{" "}
                <span className="text-muted-foreground">
                  {analytics?.videoUrlTotalClicks} cliques |{" "}
                  {getVideoPurchases()} compras
                </span>
              </p>
              <div
                className="flex items-center justify-between h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background cursor-pointer"
                type="text"
                onClick={() => copyToClipboard(referrerDoc2.videoLink, "video")}
              >
                <p className="text-muted-foreground">
                  {referrerDoc2
                    ? referrerDoc2.videoLink
                      ? referrerDoc2.videoLink
                      : "Gerando link, aguarde..."
                    : ""}
                </p>
                {textCopied === "video" ? (
                  <CheckCircledIcon className="text-green-500 w-4 h-4" />
                ) : (
                  <CopyIcon className="text-blue-400 w-4 h-4" />
                )}
              </div>
              {textCopied === "video" ? (
                <p className="text-green-500 text-sm mt-2.5">
                  Link copiado para a área de transferência.
                </p>
              ) : null}
              <p className="mt-5 text-sm mb-1.5">
                Página de pagamentos{" "}
                <span className="text-muted-foreground">
                  {analytics?.checkoutUrlTotalClicks} cliques |{" "}
                  {getPayPurchases()} compras
                </span>
              </p>
              <div
                className="flex items-center justify-between h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background cursor-pointer"
                type="text"
                onClick={() =>
                  copyToClipboard(referrerDoc2.checkoutLink, "checkout")
                }
              >
                <p className="text-muted-foreground">
                  {referrerDoc2
                    ? referrerDoc2.checkoutLink
                      ? referrerDoc2.checkoutLink
                      : "Gerando link, aguarde..."
                    : ""}
                </p>
                {textCopied === "checkout" ? (
                  <CheckCircledIcon className="text-green-500 w-4 h-4" />
                ) : (
                  <CopyIcon className="text-blue-400 w-4 h-4" />
                )}
              </div>
              {textCopied === "checkout" ? (
                <p className="text-green-500 text-sm mt-2.5">
                  Link copiado para a área de transferência.
                </p>
              ) : null}

              <div className="pt-1.5"></div>
            </>
          ) : (
            <>
              <h3>
                Para participar do <b>Programa de Recompensas</b> do Steady
                Gainz, leia o regulamento abaixo, aceite os termos e clique no
                botão para confirmar a sua inscrição.{" "}
              </h3>
              <div className="mt-5">
                <h4>Regulamento:</h4>
                <p className="mt-2.5 text-muted-foreground">
                  1. a Money Academy pagará 100 reais para cada usuário que
                  indicar um amigo que, através dessa indicação, comprar a
                  licença de uso da Money Academy.{" "}
                  <u>
                    A indicação será válida para pagamento através deste
                    programa de recompensas apenas após o usuário indicado
                    passar dos 30 dias de garantia.
                  </u>
                </p>
                <p className="mt-2.5 text-muted-foreground">
                  2. Os pagamentos serão feitos uma vez por mês, todo dia 1º de
                  cada mês. Ou seja, todo dia primeiro de cada mês você receberá
                  o pagamento das indicações válidas (usuários indicados que já
                  passaram do período de garantia).
                </p>
                <p className="mt-2.5 text-muted-foreground">
                  3. O pagamento será realizado via Pix para uma conta bancária
                  da titularidade do usuário participante deste Programa de
                  Recompensas.
                </p>
                <p className="mt-2.5 text-muted-foreground">
                  4. Para estar habilitado a receber as comissões geradas pelas
                  indicações válidas, você precisa ser um usuário do Steady
                  Gainz com um plano ativo.
                </p>
                <div className="mt-5 flex gap-1.5 items-center">
                  <Checkbox
                    id="terms"
                    checked={userAcceptedTerms}
                    onCheckedChange={() => {
                      if (userAcceptedTerms === false) {
                        setErrorMessage("");
                      }
                      setUserAcceptedTerms((prev) => !prev);
                    }}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm text-muted-foreground font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    Declaro que li e aceito o regulamento e quero participar do
                    Programa de Recompensas
                  </label>
                </div>
                {errorMessage ? (
                  <p className="text-red-500 text-sm mt-2.5">{errorMessage}</p>
                ) : null}
                <Button className="mt-5" onClick={subscribeToRewardsProgram}>
                  Participar do Programa de Recompensas
                </Button>
              </div>
            </>
          )}
        </CardContent>
      </Card>
      {referrerDoc2.acceptedTerms2 && (
        <Card className="mt-2.5 w-full">
          <CardContent className="p-5">
            <h3 className="mb-1.5">Dados para pagamento:</h3>
            <div className="flex flex-col sm:flex-row gap-1.5">
              <Input
                type="text"
                placeholder="Informe seu nome completo"
                value={paymentDetails.name}
                onChange={(e) =>
                  setPaymentDetails({
                    ...paymentDetails,
                    name: e.target.value,
                  })
                }
              />
              <Input
                type="text"
                placeholder="Informe a sua chave Pix"
                value={paymentDetails.pixKey}
                onChange={(e) =>
                  setPaymentDetails({
                    ...paymentDetails,
                    pixKey: e.target.value,
                  })
                }
              />
              <Button onClick={savePaymentDetails}>
                Salvar dados para pagamento
              </Button>
            </div>
            <div className="pt-1.5"></div>
          </CardContent>
        </Card>
      )}
      {referrerDoc2.acceptedTerms2 && (
        <Card className="mt-2.5 w-full">
          <CardContent className="p-5">
            <h3 className="mb-2.5">Ranking de Parceiros:</h3>
            <ul className="flex flex-col gap-2.5">
              {referrals2 &&
                referrals2.map((referral, index) => (
                  <li
                    key={referral.referrerId}
                    className="flex items-center justify-between"
                  >
                    <div className="flex items-center gap-2.5">
                      <span
                        className={`${getRankColor(
                          index
                        )} py-1.5 px-3 rounded-sm`}
                      >
                        {index + 1}
                      </span>
                      <h3>
                        @{referral.referrerId}{" "}
                        {referral.referrerId === referrerDoc2.referrerId
                          ? "(você)"
                          : ""}
                      </h3>
                    </div>
                    <span>{referral.totalPurchases}</span>
                  </li>
                ))}
            </ul>
            <div className="pt-1.5"></div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
